import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../ui/sheet";
import { Milestone } from "./Milestone";
import { TargetFacts } from "./TargetDepartment";
import { ApplicationGuide, StationVisitGuide, OralBoardGuide, OfficialResources } from "./PhaseGuides";

const GUIDES = { application: ApplicationGuide, station: StationVisitGuide, board: OralBoardGuide };
const FACTS = new Set(["application", "testing", "station", "board_prep", "board", "chief"]);

export function PhaseDetail({ phase, data, open, onClose, isDone, onToggle }) {
  const navigate = useNavigate();
  if (!phase) return null;
  const Guide = GUIDES[phase.id];
  const hasKey = phase.items.some((i) => i.key);
  const more = hasKey ? phase.items.filter((i) => !i.key) : [];
  const a = phase.about || {};
  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent side="right" className="w-full sm:max-w-2xl overflow-y-auto p-0 [&>button]:text-white [&>button]:opacity-90" data-testid={`phase-detail-${phase.id}`}>
        <div className="bg-slate-950 text-white px-6 py-6">
          <SheetHeader className="text-left space-y-1">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-amber-400">Career Road Map · Learn more</p>
            <SheetTitle className="font-heading text-2xl text-white" data-testid="phase-detail-title">{phase.title}</SheetTitle>
            <SheetDescription className="text-slate-400 text-sm">{a.what}</SheetDescription>
          </SheetHeader>
          {(a.why || a.focus) && (
            <dl className="mt-4 grid sm:grid-cols-2 gap-3 text-sm">
              {a.why && <div className="rounded-xl bg-white/5 border border-white/10 p-3"><dt className="text-[10px] font-bold uppercase tracking-wider text-amber-400">Why it matters</dt><dd className="mt-1 text-slate-200">{a.why}</dd></div>}
              {a.focus && <div className="rounded-xl bg-white/5 border border-white/10 p-3"><dt className="text-[10px] font-bold uppercase tracking-wider text-amber-400">Focus on</dt><dd className="mt-1 text-slate-200">{a.focus}</dd></div>}
            </dl>
          )}
        </div>
        <div className="px-6 py-6 space-y-6">
          {Guide && <section><p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-3">Guidance</p><Guide target={data.target} /></section>}
          {more.length > 0 && (
            <section data-testid={`phase-detail-steps-${phase.id}`}>
              <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">Additional steps you can track</p>
              <ul className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white px-4">{more.map((i) => <Milestone key={i.id} i={i} on={isDone(i.id)} onToggle={onToggle} onGo={(to) => { onClose(); navigate(to); }} />)}</ul>
            </section>
          )}
          {FACTS.has(phase.id) && data.target?.id && <section><p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-3">Your target department</p><TargetFacts target={data.target} phase={phase.id} /></section>}
          {FACTS.has(phase.id) && <OfficialResources target={data.target} california={data.california} phase={phase.id} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
